import { type ReactElement, useState } from 'react';
import { Link } from 'react-router';
import { MY_PROFILE_PATH } from '@/shared/config';
import { Button, CheckboxField } from '@/shared/ui';
import { useWithdrawAccount } from '../model/use-withdraw-account';

/** 탈퇴 확인 — 안내를 확인했다는 체크 전에는 "탈퇴하기"가 눌리지 않는다. */
export const WithdrawForm = (): ReactElement => {
  const [confirmed, setConfirmed] = useState(false);
  const { withdraw, isPending, errorMessage } = useWithdrawAccount();

  return (
    <div className="flex flex-col gap-5">
      <CheckboxField
        label="위 내용을 모두 확인했어요"
        checked={confirmed}
        disabled={isPending}
        onChange={(event) => setConfirmed(event.target.checked)}
      />
      {errorMessage ? (
        <p role="alert" className="text-sm text-destructive">
          {errorMessage}
        </p>
      ) : null}
      <div className="flex items-center gap-4">
        <Button
          variant="destructive"
          disabled={!confirmed}
          isLoading={isPending}
          onClick={withdraw}
        >
          탈퇴하기
        </Button>
        <Link
          to={MY_PROFILE_PATH}
          className="text-sm font-semibold underline underline-offset-4 hover:no-underline"
        >
          취소
        </Link>
      </div>
    </div>
  );
};
